import { render } from "./CoBrandFolio.vue?vue&type=template&id=42f98a7c&scoped=true"
import script from "./CoBrandFolio.vue?vue&type=script&lang=js"
export * from "./CoBrandFolio.vue?vue&type=script&lang=js"

import "./CoBrandFolio.vue?vue&type=style&index=0&id=42f98a7c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42f98a7c"]])

export default __exports__